import { mobileXXLargeMax, mobileXXLargeMin } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { AreaInput } from '../inputs/TextArea.style';
import { Input } from '../inputs/TextInput.style';

export const FaqContactForm = styled.form`
  width: 100%;

  ${Input}, ${AreaInput} {
    background-color: #feede6;
  }
`;

export const FaqContactFormGrid = styled.div<{ agent?: boolean }>`
  display: grid;
  grid-template-columns: repeat(${({ agent }) => (agent ? 2 : 3)}, minmax(0, 1fr));
  gap: 20px;
  margin-bottom: 25px;

  @media (${mobileXXLargeMax}) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

export const CommentsWrapper = styled.div<{ agent?: boolean }>`
  @media (${mobileXXLargeMin}) {
    grid-area: ${({ agent }) => (agent ? '3 / 3 / 4 / 1' : '2 / 4 / 2 / 1')};
  }
`;
